import { getCurrentAppVersion } from '@/utils/SessionUtils';
import { maybe } from '@/utils';
import Subscriber from './subscriber';

class TeamSubscriber extends Subscriber {
  pendoInitialized = false;

  selectState = ({
    restricted: {
      _session: {
        session_proxy: sessionProxy,
        current_session_meta_proxy: sessionId,
      },
    },
  }) => {
    if (sessionProxy && sessionId && sessionProxy[sessionId]) {
      const {
        sessionInfo: {
          name: { firstName: firstname, lastName: lastname },
          email,
          teamInfo: {
            teamId,
            teamName,
            createdOn,
            isHardPaywall,
            teamPreferences,
          },
        },
        owner: { ownerGuid: jid },
      } = sessionProxy[sessionId];

      return {
        teamId,
        jid,
        firstname,
        lastname,
        email,
        teamName,
        createdOn,
        isHardPaywall,
        creatorEmail: maybe(teamPreferences, 'creator', 'value'),
        hourThrottle: new Date().getHours(), // also force change every hour
      };
    }
    return null;
  };

  notify = async ({
    teamId,
    jid,
    firstname,
    lastname,
    email,
    teamName,
    createdOn,
    isHardPaywall,
    creatorEmail,
  }) => {
    if (teamId && jid) {
      const options = {
        visitor: {
          id: jid,
          firstname,
          lastname,
          email,
          IsTeamCreator: creatorEmail === email,
          LatestWebVersion: await getCurrentAppVersion(),
        },
        account: {
          id: teamId,
          accountname: teamName,
          CreatedTS: createdOn,
          IsHardPaywall: isHardPaywall,
        },
      };
      if (window.pendo) {
        if (!this.pendoInitialized) {
          this.pendoInitialized = true;
          window.pendo.initialize(options);
        } else {
          window.pendo.updateOptions(options);
          if (window.pendo.loadGuides) {
            window.pendo.loadGuides();
          }
        }
      }
    }
  };
}

export default new TeamSubscriber('team');



// WEBPACK FOOTER //
// ./src/store/subscribers/team.js